export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE_NUMBER: 1,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

/**
 * Date format constants for consistent date formatting across the app
 */
export const DATE_FORMAT = {
  DISPLAY: 'dd/MM/yyyy',
  DISPLAY_DATETIME: 'dd/MM/yyyy HH:mm:ss',
  API: 'yyyy-MM-dd',
} as const;

export const STATUS_CODE = {
  OK: '01',
  NG: '02',
} as const;

export const STATUS = {
  ACTIVE: STATUS_CODE.OK,
  INACTIVE: STATUS_CODE.NG,
} as const;

/**
 * Check if status code is OK (active/success).
 * @param status - Status code from API response ('01' = OK, '02' = NG)
 */
export const isActiveStatus = (status: string | null | undefined): boolean => {
  return status === STATUS_CODE.OK;
};

// Alias for activity logs - same logic, different semantic
export const isSuccessStatus = isActiveStatus;

export const CACHE_TIME = {
  STALE_TIME: 0,
  GC_TIME: 5 * 60 * 1000,
  MAX_RETRY_DELAY: 5000,
  BASE_RETRY_DELAY: 1000,
} as const;

export const RETRY = {
  MAX_QUERY_RETRIES: 3,
  NO_RETRY_STATUS_MIN: 400,
  NO_RETRY_STATUS_MAX: 500,
} as const;

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;
